import React, { useRef } from 'react';
import { DrawerContainer } from './styles/vaStyles';
import handle from '../../../../assets/icons/drawer_handle.svg';

export const MobileDrawer = (props: any) => {
  const { onClose, open } = props;
  const touchStartY: any = useRef(0);
  const touchEndY: any = useRef(0);

  const onTouchStart = (e: any) => {
    touchStartY.current = e.touches[0].clientY;
  };

  const onTouchMove = (e: any) => {
    touchEndY.current = e.touches[0].clientY;
  };

  const onTouchEnd = () => {
    const swipeDistance = touchEndY.current - touchStartY.current;
    if (swipeDistance > 50) {
      touchEndY.current = null;
      touchStartY.current = null;
      onClose();
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Escape' || e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClose();
    }
  };

  return (
    <DrawerContainer
      placement="bottom"
      closable={false}
      onClose={onClose}
      open={open}
      key="bottom"
      maskClosable={true}
      headerStyle={{ border: 'none' }}
      height={'auto'}
    >
      <div
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
        onClick={(e) => e.stopPropagation()}
        role="presentation"
      >
        <div
          className="handle"
          onClick={onClose}
          onKeyDown={handleKeyDown}
          role="button"
          tabIndex={0}
          aria-label="Close drawer"
        >
          <img src={handle} alt="handle logo" />
        </div>
        {props.children}
      </div>
    </DrawerContainer>
  );
};
